import React, { useEffect, useState } from 'react'
import { Box, useTheme } from '@mui/material'

import MasterAppBar from '../master/components/MasterAppBar'
import CourseContent from './components/CourseContent'
import CourseProgressBar from './components/CourseProgressBar'
import CourseSections from './components/CourseSections'
import Footer from '../master/components/Footer'
import ScopedCssBaseline from '@mui/material/ScopedCssBaseline';
import { useParams } from 'react-router-dom'
import { useAuthContext } from '../auth/hooks/useAuthContext';
import { fetchCourses } from '../../services/desktopData';
function Course() {
  const params = useParams()
  const theme = useTheme();
  const { user } = useAuthContext();
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    let active = true;
    fetchCourses(user).then((courses) => {
      const current = courses.find((course) => String(course.id) === String(params.id));
      if (active && current) setProgress(current.progress);
    }).catch(() => {});
    return () => { active = false; };
  }, [params.id, user]);
  return (
    <ScopedCssBaseline>
      <Box>
        <MasterAppBar crumb={true} />
        <CourseProgressBar data={{ progress }} />
        <Box sx={{ width: '80vw', margin: 'auto', padding: '2rem', border: `1px solid ${theme.palette.background.gray}`, borderRadius: '5px' }}>
          <CourseSections course_id={params?.id} teacherUserId={params?.teacher_user_id} />
          <CourseContent />
        </Box>
        <Footer />
      </Box>
    </ScopedCssBaseline>

  )
}

export default Course
